import type { CommentsSortUi } from '../../../api/types/projects'

export type { CommentsSortUi }

/** Дефолт сортировки корня ленты комментариев в UI и API.
 * Единственный источник правды: новые разделы с комментариями обязаны использовать эту константу
 * (см. docs/patterns/frontend.md §13 — чеклист). Не хардкодить `'interesting'` / `'new'`. */
export const DEFAULT_COMMENTS_SORT: CommentsSortUi = 'interesting'

export type CommentsSortApiParams = {
  sort_by?: 'published_at' | 'popularity'
  sort_direction?: 'asc' | 'desc'
}

export function commentsSortUiToQuery(sort: CommentsSortUi | undefined): CommentsSortApiParams {
  const resolved = sort ?? DEFAULT_COMMENTS_SORT
  switch (resolved) {
    case 'old':
      return { sort_by: 'published_at', sort_direction: 'asc' }
    case 'interesting':
      return { sort_by: 'popularity' }
    case 'new':
    default:
      return { sort_by: 'published_at', sort_direction: 'desc' }
  }
}

export function appendCommentsSortQueryParams(
  params: Record<string, string>,
  sort: CommentsSortUi | undefined,
): void {
  const { sort_by, sort_direction } = commentsSortUiToQuery(sort)
  if (sort_by) {
    params.sort_by = sort_by
  }
  if (sort_direction) {
    params.sort_direction = sort_direction
  }
}
